import React from 'react'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { ContentContainer } from '../components/content-container'
import { RecruitContactSection } from '../components/recruit-contact-section'
import SvgRecruitTitle11 from '../generated/svg/recruit-title-11'
import { HeaderImageContainer, InterviewTitle } from './recruit-page'

const Outer = styled.div`
  --background-color: #f5e6ec;
`

type RecruitContactPageProps = {

}
export const RecruitContactPage: FunctionComponent<RecruitContactPageProps> = () => {
  return <Outer>
    <HeaderImageContainer>
      <AutoImage src="/images/recruit_header.jpg" mobileSrc="/images/recruit_header_mobile.jpg" />
    </HeaderImageContainer>
    <ContentContainer>
      <InterviewTitle>
        <SvgRecruitTitle11 />
      </InterviewTitle>
      <RecruitContactSection />
    </ContentContainer>
  </Outer>
}